@if (user(); as user) {
  <ion-item
    button
    routerDirection="root"
    routerLink="/user"
    routerLinkActive="selected"
  >
    @if (user.photoURL) {
      <ion-avatar slot="start">
        <img
          src="{{ user.photoURL }}"
          alt="Avatar utilisateur"
          loading="lazy"
        />
      </ion-avatar>
    } @else {
      <ion-icon name="person-circle" aria-hidden="true" slot="start" />
    }
    <ion-label>
      <ion-text color="success">
        <h4>{{ user.username }}</h4>
      </ion-text>
    </ion-label>
  </ion-item>
} @else {
  <ion-item (click)="openLoginModal()" button>
    <ion-icon
      name="log-in-outline"
      aria-hidden="true"
      color="dark"
      slot="start"
    />
    <ion-label>Connexion</ion-label>
  </ion-item>
}
